<template>
  <v-container fluid>
    <alert-unsaved-changes v-if="unsavedChanges"></alert-unsaved-changes>
    <v-progress-linear
      v-show="loading || resourceLoading"
      color="neutral400"
      indeterminate
      rounded
      height="3"
    ></v-progress-linear>
    <v-form
      v-show="!loading && !resourceLoading"
      ref="form"
      v-model="valid"
      :lazy-validation="false"
    >
      <v-row>
        <v-col v-if="!next" cols="12">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('optional-info') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-10">
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <label>Service Level</label>
                    <p class="label-info">
                      Webpage with the information about the levels of performance that a Provider
                      is expected to deliver.
                    </p>
                    <v-text-field
                      v-model="resource.serviceLevel"
                      :placeholder="'Paste a Url'"
                      outlined
                      :disabled="!edit"
                      :rules="checkURL()"
                      clearable
                      data-cy="serviceLevel"
                      prepend-inner-icon="mdi-link-variant"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-form>
    <!--BUTTONS-->
    <v-row class="mt-10" v-if="next">
      <v-col cols="6" class="d-flex justify-end">
        <v-btn
          depressed
          rounded
          x-large
          color="black"
          @click="back()"
          outlined
          class="black--text font-weight-bold"
          data-cy="submit"
        >
          <v-icon color="black">$vuetify.icons.back</v-icon>
          {{ $t('back') }}
        </v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn
          depressed
          rounded
          x-large
          color="neutral"
          @click="add()"
          :disabled="!valid"
          class="white--text font-weight-bold"
          data-cy="submit"
          >{{ $t('submit') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="my-5" v-if="!next && edit" justify="end">
      <v-btn outlined class="black--text font-weight-bold mx-2" rounded x-large @click="cancel()">
        {{ $t('cancel') }}
      </v-btn>
      <v-btn
        depressed
        rounded
        x-large
        color="primary200"
        class="white--text font-weight-bold"
        @click="add()"
        :disabled="!valid"
        >{{ $t('update') }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import util from '@/mixins/util.js';
import AlertUnsavedChanges from '@/components/shared/helpers/AlertUnsavedChanges';
import base from '@/services/base-service.js';

export default {
  name: 'ResourceManagementInfo',
  mixins: [util, base],
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: null,
    },
    edit: {
      type: Boolean,
      default: true,
    },
    next: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    AlertUnsavedChanges,
  },
  data() {
    return {
      valid: false,
      loadingComponents: -1,
      unsavedChanges: false,
      resource: {
        id: null,
        serviceLevel: null,
        userManual: null,
        trainingInformation: null,
      },
      resourceLoading: true,
    };
  },
  mounted() {
    this.loadingComponents++;
  },
  methods: {
    cancel() {
      this.$emit('cancel', true);
      this.unsavedChanges = false;
    },
    back() {
      console.log('back!');
      this.$emit('tab', 2);
    },
    add() {
      EventBus.$emit('waiting', true);
      this.axios
        .post('/api/v1/resources/management-info', this.resource)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('resource-updated'),
          });
          this.unsavedChanges = false;
        })
        .catch(error => {
          console.log({ error });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
  },
  computed: {
    loading() {
      return this.loadingComponents !== 0;
    },
  },
  watch: {
    loading(value) {
      if (value === false) {
        console.log('Loading');
        if (this.id != null) {
          this.axios
            .get('/api/v1/resources/' + this.id)
            .then(res => {
              this.resource = res.data;
              this.$nextTick(() => {
                this.resourceLoading = false;
              });
            })
            .catch(error => {
              console.log({ error });
            });
        } else {
          this.resourceLoading = false;
        }
      }
    },
    resource: {
      handler: function(val, oldVal) {
        console.log('[Resource] Value changed');
        if (oldVal.id) {
          this.unsavedChanges = true;
        }
      },
      deep: true,
    },
  },
};
</script>
